/**
 * @voltxampere/ui — ESP8266 (NodeMCU) variant (Sprint 43-5, placeholder)
 *
 * PLACEHOLDER. Full GPIO + ADC + PWM + I2C + SPI + WiFi simulation
 * arrives Sprint 46+ (Xtensa L106 single-core family).
 *
 * Reference: Espressif ESP8266EX (NodeMCU module). Xtensa L106 32-bit.
 * Vcc 2.5-3.6 V, fmax 80/160 MHz, 1-4 MB external Flash / 80 KB SRAM,
 * 17 GPIO, 1 ADC channel (10-bit), 4 PWM, 2× UART / 1 SPI / 1 I2C
 * (software), WiFi 802.11 b/g/n.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const mcuEsp8266 = {
    id: "esp8266",
    nameTr: "ESP8266 (NodeMCU, placeholder)",
    nameEn: "ESP8266 (NodeMCU, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "ESP8266",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOT",
        vHigh: 3.3,
        vLow: 0,
        threshold: 1.65,
        propagationDelay: 12e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=mcu-esp8266.js.map